import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../authentication/authentication.service';

@Component({
  selector: 'app-access-recovery',
  templateUrl: './access-recovery.component.html',
  styleUrls: ['../../../../assets/scss/_auth-status.scss', './access-recovery.component.scss'],
  standalone: false
})
export class AccessRecoveryComponent {
  reason: string;
  returnUrl: string;

  constructor(
    route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService
  ) {
    const reason = route.snapshot.queryParamMap.get('reason');
    this.reason = reason === 'permission' || reason === 'profile' ? reason : 'session';
    const requested = route.snapshot.queryParamMap.get('returnUrl');
    this.returnUrl = requested && requested.startsWith('/') && !requested.startsWith('//')
      && !requested.includes('\\') && !/^\/access-recovery(?:[/?;#]|$)/.test(requested) ? requested : '/';
  }

  signIn() {
    this.authService.login();
  }

  retry() {
    this.router.navigateByUrl(this.returnUrl);
  }
}
